'use client'
import { BreadcrumbItem as ChakraBreadcrumbItem } from '@chakra-ui/react'
import { forwardRef, LegacyRef } from 'react'

import { BreadcrumbItemProps } from './BreadcrumbItem.types'

export default forwardRef(function BreadcrumbItem(
  props: BreadcrumbItemProps,
  ref: LegacyRef<HTMLLIElement>
) {
  return <ChakraBreadcrumbItem {...props} ref={ref} translate="no" />
})
